import IconButton from "@material-ui/core/IconButton/IconButton";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import "./scss/pagination.scss";
import Link from "@material-ui/core/Link";

interface IProps {
    currentPage: number;
    totalPages: number;
    setCurrentIndex(index: number): void;
}

export const Pagination = (props: IProps) => {
    const { currentPage, totalPages, setCurrentIndex } = props;
    const displayAmountOfPages = 10;
    const startIndex = Math.max(1, currentPage - displayAmountOfPages / 2);
    const endIndex = Math.min(totalPages, currentPage + displayAmountOfPages / 2);

    const createPagination = () => {
        const pagination = [];
        for (let index = startIndex; index <= endIndex; index++) {
            pagination.push(
                <Link
                    className={index === currentPage + 1 ? "active" : ""}
                    color="inherit"
                    data-testid={`li-${index}`}
                    href="#"
                    key={index}
                    underline="none"
                    onClick={() => setCurrentIndex(index - 1)}
                >
                    <li>{index}</li>
                </Link>
            );
        }

        return pagination;
    };

    return (
        <div className="pagination">
            <ul>
                <IconButton
                    color={currentPage === 0 ? "inherit" : "secondary"}
                    component="div"
                    disabled={currentPage === 0}
                    onClick={() => setCurrentIndex(currentPage - 1)}
                >
                    <KeyboardArrowLeft />
                </IconButton>
                {createPagination()}
                <IconButton
                    color={currentPage === totalPages - 1 ? "inherit" : "secondary"}
                    component="div"
                    disabled={currentPage === totalPages - 1}
                    onClick={() => setCurrentIndex(currentPage + 1)}
                >
                    <KeyboardArrowRight />
                </IconButton>
            </ul>
        </div>
    );
};
